import React from 'react';

const ButtonItemPreview = ({ button, from, style }) => {
	const { position, buttonColor, textColor, source, size, text } = button;

	const fromButton = from === 'WidgetButton';
	const fromStandardHomescreen = from === 'nativeLayoutHelpers';

	return (
		<div
			className="button-preview"
			style={{
				width: fromButton ? '100%' : 'auto',
				height: fromStandardHomescreen ? '100%' : 'auto',
				backgroundColor: buttonColor ? buttonColor : '#AAAAAA',
				justifyContent: source ? (position === 'right' ? 'space-between' : 'left') : 'center',
				fontSize: size === 'large' ? '1.5em' : '1em',
				...style,
			}}
		>
			{source ? (
				<>
					{position === 'right' && (
						<span style={{ color: textColor ? textColor : '#FFFFFF' }}>
							{text ? text : 'Button'}
						</span>
					)}
					<img
						src={source.src || source.uri}
						style={{
							width: '40px',
							aspectRatio: 1,
							objectFit: 'contain',
							margin: position === 'right' ? '0 0 0 15px' : '0 15px 0 0',
						}}
						alt={source.name}
					/>
					{position === 'left' && (
						<span style={{ color: textColor ? textColor : '#FFFFFF' }}>
							{text ? text : 'Button'}
						</span>
					)}
				</>
			) : (
				<span style={{ color: textColor ? textColor : '#FFFFFF', textAlign: 'center' }}>
					{text ? text : 'Button'}
				</span>
			)}
		</div>
	);
};

export default ButtonItemPreview;
